import React, { useEffect, useRef, useState } from 'react';
import './style.scss';
import { Enviroment } from '../../../../../../../../../_config/constants/enviroment-v2.constant';

const GOOGLE_MAPS_API_KEY = Enviroment.GOOGLE_MAPS_KEY

// Default center for Chile (Santiago)
const DEFAULT_CENTER = {
  lat: -33.4489,
  lng: -70.6693,
};

const DEFAULT_ZOOM = 12;
const MARKER_ZOOM = 16;

export default function GoogleMapComponent({ coordinates, validatedAddress }) {
  const mapRef = useRef(null);
  const [map, setMap] = useState(null);
  const [marker, setMarker] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);

  // Load Google Maps script dynamically
  useEffect(() => {
    if (window.google && window.google.maps) {
      setIsLoaded(true);
      return;
    }

    // Check if script is already being loaded
    const existingScript = document.querySelector('script[src*="maps.googleapis.com"]');
    if (existingScript) {
      existingScript.addEventListener('load', () => setIsLoaded(true));
      return;
    }

    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_API_KEY}&libraries=places`;
    script.async = true;
    script.defer = true;
    script.onload = () => setIsLoaded(true);
    script.onerror = () => console.error('Error loading Google Maps');
    document.head.appendChild(script);

    return () => {
      // Don't remove script on cleanup as it may be used elsewhere
    };
  }, []);

  // Initialize map
  useEffect(() => {
    if (!isLoaded || !mapRef.current || map) return;

    const newMap = new window.google.maps.Map(mapRef.current, {
      center: DEFAULT_CENTER,
      zoom: DEFAULT_ZOOM,
      disableDefaultUI: true,
      zoomControl: true,
      mapTypeControl: false,
      streetViewControl: false,
      fullscreenControl: false,
    });

    setMap(newMap);
  }, [isLoaded, map]);

  // Update map when coordinates change
  useEffect(() => {
    if (!map) return;

    if (coordinates) {
      const position = {
        lat: coordinates.lat,
        lng: coordinates.lng,
      };

      map.setCenter(position);
      map.setZoom(MARKER_ZOOM);

      // Remove existing marker if any
      if (marker) {
        marker.setMap(null);
      }

      // Create new marker
      const newMarker = new window.google.maps.Marker({
        position,
        map,
        title: validatedAddress || 'Ubicación seleccionada',
        animation: window.google.maps.Animation.DROP,
      });

      // Add info window
      if (validatedAddress) {
        const infoWindow = new window.google.maps.InfoWindow({
          content: `<div style="padding: 8px; font-size: 14px;">${validatedAddress}</div>`,
        });

        newMarker.addListener('click', () => {
          infoWindow.open(map, newMarker);
        });
      }

      setMarker(newMarker);
    } else {
      // Reset to default view
      map.setCenter(DEFAULT_CENTER);
      map.setZoom(DEFAULT_ZOOM);

      if (marker) {
        marker.setMap(null);
        setMarker(null);
      }
    }
  }, [map, coordinates, validatedAddress]);

  if (!GOOGLE_MAPS_API_KEY) {
    return (
      <div className="google-map-placeholder">
        <p>Configure Google Maps API Key para ver el mapa</p>
      </div>
    );
  }

  return (
    <div className="google-map-container">
      <div 
        ref={mapRef} 
        className="google-map"
        style={{ width: '100%', height: '100%' }}
      />
      {!isLoaded && (
        <div className="map-loading">
          <span>Cargando mapa...</span>
        </div>
      )}
    </div>
  );
}
